import React from 'react';
import { Link } from 'react-scroll';
import { FaPhone, FaArrowRight } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
    return (
        <section className="hero" id="hero">
            <div className="hero-overlay"></div>
            <div className="container">
                <div className="hero-content">
                    <div className="hero-text">
                        <h1 className="hero-title">
                            Premium Healthcare Services
                            <span className="text-gradient"> At Your Doorstep</span>
                        </h1>
                        <p className="hero-description">
                            Adarsh Old Age Care Home Services is a trusted provider of old age care, elder care services, and senior citizen care. We offer compassionate support for senior citizens, including daily assistance, health monitoring, and personalized care in Thane, Mumbai, and Navi Mumbai.
                        </p>
                        <div className="hero-buttons">
                            <a href="tel:9082033873" className="btn btn-primary">
                                <FaPhone /> Call 9082033873
                            </a>
                            <Link
                                to="contact"
                                smooth={true}
                                offset={-80}
                                duration={500}
                                className="btn btn-secondary"
                            >
                                Book Service <FaArrowRight />
                            </Link>
                        </div>
                        <div className="hero-features">
                            <div className="hero-feature">
                                <span className="feature-icon">✓</span>
                                <span>4+ Years Experience</span>
                            </div>
                            <div className="hero-feature">
                                <span className="feature-icon">✓</span>
                                <span>100% Trained Staff</span>
                            </div>
                            <div className="hero-feature">
                                <span className="feature-icon">✓</span>
                                <span>24/7 Available</span>
                            </div>
                        </div>
                    </div>
                    <div className="hero-image">
                        <div className="hero-card">
                            <div className="card-icon">🏥</div>
                            <h3>Professional Care</h3>
                            <p>Certified & experienced healthcare professionals</p>
                        </div>
                        <div className="hero-card">
                            <div className="card-icon">⭐</div>
                            <h3>5-Star Rated</h3>
                            <p>25+ Google reviews from satisfied clients</p>
                        </div>
                        <div className="hero-card">
                            <div className="card-icon">🛡️</div>
                            <h3>Verified Staff</h3>
                            <p>Background checked & thoroughly trained</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;